<template>
  <div class="wrapper">
    <template>
      <SuccessfulPurchase
        :installmentSelectedLabel="installmentSeletedLabel"
        :paymentType="paymentType"
        :upsell="upSell"
      />
    </template>
    <template v-if="upSell">
      <PaymentCardUpSell
        :creditCardFlag="creditCardFlag"
        :creditCardLastDigits="creditCardLastDigits"
        :installmentSeletedLabel="installmentSeletedLabel"
        :paymentType="currentPaymentTypeSelected"
      />
    </template>
  </div>
</template>

<script>
import themeMixin from '@/components/mixins/themeMixin'
import { mapGetters, mapMutations, mapState } from 'vuex'
import { injectPixelScript } from '@/utils/pixels/injectPixelScript'
import { pixelPurchaseParams } from '@/utils/pixels/pixelPurchaseParams'
import SuccessfulPurchase from '@/views/Checkout/partials/SuccessfulPurchase/SuccessfulPurchase.vue'
import PaymentCardUpSell from '@/views/Checkout/partials/steps/Payment/PaymentSuccess/PaymentCardUpSell/PaymentCardUpSell.vue'

export default {
  name: 'PaymentSuccess',
  components: {
    PaymentCardUpSell,
    SuccessfulPurchase,
  },
  mixins: [themeMixin],
  props: {},
  data: () => ({
    paymentTypesChangePaymentButton: ['billet', 'pix'],
    upSell: null,
    installmentSelected: {
      type: [String, Object],
    },
    creditCardFlag: {
      type: String,
    },
    creditCardLastDigits: {
      type: String,
    },
    mockCard: {
      label: '',
    },
  }),
  computed: {
    ...mapState('Checkout', {
      paymentCard: (state) => state.paymentCard,
      cart: (state) => state.cart,
      pixels: (state) => state.pixels,
    }),
    ...mapGetters('Checkout', {
      paymentType: 'getPaymentType',
    }),
    ...mapGetters('Cart', ['getFirstUpsell'], {
      items: 'getItems',
    }),
    currentPaymentTypeSelected() {
      return this.paymentType
    },
    installmentSeletedLabel() {
      // TODO: será necessário que o serviço do carrinho devolva os parâmetrs do pagamento.
      return this.paymentCard?.installments?.label || this.mockCard.label
    },
  },
  watch: {
    getFirstUpsell: {
      handler(upSell) {
        this.upSell = upSell
      },
      deep: true,
    },
  },
  beforeMount() {
    if (this.$route.params?.creditCardDetails) {
      Object.assign(this, this.$route.params.creditCardDetails)
    }
  },
  mounted() {
    this.loadCheckoutPixel()
    this.SET_CURRENT_STEP(-1)
  },
  methods: {
    ...mapMutations('Checkout', ['SET_CURRENT_STEP']),
    loadCheckoutPixel() {
      try {
        const pixels = pixelPurchaseParams(this.pixels, this.cart, 'credit_card')

        if (pixels.length) {
          injectPixelScript(pixels, 'purchase')
        }
      } catch (error) {
        throw new Error(error)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
}
</style>
